import * as React from 'react'
import styled from '@emotion/styled'

import { ISelectRowsFunction } from './../../../../../Interfaces'
import RowText from './RowText'
import RowCheckbox from './RowCheckbox'
import { PADDING } from '../../../../../Constants'

const Container = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    cursor: pointer;

    padding: ${PADDING}px;

    :hover {
        background-color: ${({ theme, disabled }) =>
            !disabled && theme.componentExtensions.inputs.bgInputDropdownHover};
    }
`

const Hr = styled.div`
    border-color: ${({ theme }) => theme.colors.neutralsGrey60};
    border-bottom: 1px solid;
    height: 100%;
    position: absolute;

    width: 95%;
    margin: auto;
`

interface IRowProps<T> {
    checkboxSelectable: boolean
    selectAction: ISelectRowsFunction<T | boolean | any>
    virtualizedListRowStyle: React.CSSProperties
    rowSelected: boolean
    renderHr: boolean
    disabled: boolean
    rowItemComponentInstance: JSX.Element
    testId?: string
}

export default class Row<T> extends React.Component<IRowProps<T>> {
    static readonly defaultProps = {
        renderHr: false,
        disabled: false,
    }

    render(): React.ReactNode {
        const {
            virtualizedListRowStyle,
            checkboxSelectable,
            rowSelected,
            selectAction,
            renderHr,
            disabled,
            rowItemComponentInstance,
            testId,
        } = this.props

        return (
            <Container
                className="ctr-dropdown-row"
                onClick={selectAction}
                style={virtualizedListRowStyle}
                disabled={disabled}
                data-testid={testId}
            >
                {checkboxSelectable && (
                    <RowCheckbox disabled={disabled} handleClick={selectAction} value={rowSelected} />
                )}
                <RowText checkboxSelectable={checkboxSelectable} rowItemComponentInstance={rowItemComponentInstance} />
                {renderHr && <Hr />}
            </Container>
        )
    }
}
